import React from 'react';

export default function PandaHero() {
  return (
    <div className="hero-logo-wrapper">
      <div className="hero-blob" />
      <img src="/panda.png" alt="Panda" className="hero-logo" />
    </div>
  );
}
